import { render, staticRenderFns } from "./LoadingIcon.vue?vue&type=template&id=4d15646c&scoped=true"
import script from "./LoadingIcon.vue?vue&type=script&lang=js"
export * from "./LoadingIcon.vue?vue&type=script&lang=js"
import style0 from "./LoadingIcon.vue?vue&type=style&index=0&id=4d15646c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d15646c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/Companion.WebApp/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d15646c')) {
      api.createRecord('4d15646c', component.options)
    } else {
      api.reload('4d15646c', component.options)
    }
    module.hot.accept("./LoadingIcon.vue?vue&type=template&id=4d15646c&scoped=true", function () {
      api.rerender('4d15646c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/LoadingIcon.vue"
export default component.exports